/**
 * Development-only logging helpers.
 *
 * `dlog` and `dinfo` are forwarded to console.log / console.info in
 * development, and become no-ops in production builds (NODE_ENV ===
 * 'production'). Create React App inlines `process.env.NODE_ENV` at
 * build time, so the production bundle drops these calls entirely
 * via dead-code elimination -- no runtime cost.
 *
 * Continue to use `console.warn` and `console.error` directly for
 * problems that are worth surfacing in production. This helper is
 * only for diagnostic chatter.
 *
 * Usage:
 *   import { dlog } from '../utils/debug';
 *   dlog('Initializing MSAL...');
 */

const isDev = process.env.NODE_ENV !== 'production';

export const dlog = isDev
  ? (...args) => console.log(...args) // eslint-disable-line no-console
  : () => {};

export const dinfo = isDev
  ? (...args) => console.info(...args) // eslint-disable-line no-console
  : () => {};
